
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, GetTrialNotes, GetMetadataResponse, Participant, MetadataEvent, MetadataEventForm, MetadataForm, MetadataFormVersion, MetadataItemGroup, MetadataItem, MetadataItemValue, GetMetadata, CachedMetadata } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<GetMetadataResponse, GetMetadataResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetMetadataResponse, GetMetadataResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetMetadataResponse, GetMetadataResponse>) => ({});

export const useMetadata = (trialId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!trialId) {
            return undefined;
        }

        return () => {
            return new CachedMetadata({ trialId });
        }
    }, [trialId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useMetadata;